import './pdf-page.css'

import React, { useState } from "react";
import { Document, Page } from "react-pdf";

export default function SinglePage(props) {
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1); //setting 1 to show first page

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
        setPageNumber(1);
    }

    function changePage(offset) {
        setPageNumber(prevPageNumber => prevPageNumber + offset);
    }

    function previousPage() {
        changePage(-1);
    }

    function nextPage() {
        changePage(1);
    }

    function loadingDocument() {
        return 'Chargement du document...';
    }

    function onDocumentLoadError() {
        return <h2>Erreur lors du chargement du document, veuillez réessayer en cliquant <a href="#" onClick={() => reloadPage()}>ici</a>.</h2>;
    }

    const reloadPage = () => {
        window.location.reload();
    }

    function onPageLoadError() {
        return 'Erreur lors du chargement de la page';
    }

    const { pdf } = props;

    return (
        <div className="pdf-page">
            <Document file={pdf} options={{ workerSrc: "/pdf.worker.js" }} onLoadSuccess={onDocumentLoadSuccess} loading={loadingDocument} error={onDocumentLoadError}>
                <Page pageNumber={pageNumber} loading={loadingDocument} error={onPageLoadError} />
            </Document>
            <div className="pdf-button">
                <button type="button" disabled={pageNumber <= 1} onClick={previousPage}>Précédent</button>
                <p>Page {pageNumber || (numPages ? 1 : "--")} sur {numPages || "--"}</p>
                <button type="button" disabled={pageNumber >= numPages} onClick={nextPage}>Suivant</button>
            </div>
        </div>
    );
}
